var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.itemCount)?_c('SfProperty',{staticClass:"sidebar-item-count moomin-property--large",attrs:{"name":_vm.title,"value":_vm.itemCount}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }